const projects = [
  {
    img: "https://storage.readdy-site.link/project_files/794a5293-cda5-4671-85cd-f7f0aa607761/00353f55-9878-4b16-b3d5-f88a4266b7f8_WhatsApp-Image-2026-04-08-at-19.34.40.jpeg?v=27835b0cb648b8fe99cabf4ce9154291",
    label: "Hausmeisterservice",
    location: "Mülheim",
    desc: "WEG-Betreuung Wohnanlage",
  },
  {
    img: "https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/b5db43f313e3b86cd0b118eee53983b8.jpeg",
    label: "Grünpflege",
    location: "Mülheim",
    desc: "Gartenpflege & Grünanlagen",
  },
  {
    img: "https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/c6dd2bed03f5e1b320ca04b15cd828fd.jpeg",
    label: "Wohnungsreinigung",
    location: "Essen",
    desc: "Grundreinigung nach Sanierung",
    objectPos: "object-center",
  },
  {
    img: "https://storage.readdy-site.link/project_files/794a5293-cda5-4671-85cd-f7f0aa607761/9f5577ac-cef4-4aab-8861-14c2b4e61344_l_330e8d4da0.gif?v=a378736c769f6ccca48ffa748ae82362",
    label: "Fassadenreinigung",
    location: "Düsseldorf",
    desc: "Fassadenreinigung – Vorher/Nachher",
    objectPos: "object-center",
  },
  {
    img: "https://storage.readdy-site.link/project_files/794a5293-cda5-4671-85cd-f7f0aa607761/ac120ffd-07b3-4df5-88cd-2d28a6fd09fe_WhatsApp-Image-2026-04-08-at-19.52.30-9.jpeg?v=2e18fb593cc0f1783d6bbc71e980c286",
    label: "Büroreinigung",
    location: "Ratingen",
    desc: "Bürogebäude, Gewerbeimmobilie",
  },
  {
    img: "https://static.readdy.ai/image/42a59d03aabdb3bbb4adf980fce8c22a/38627855da9ed16c4c1304529f9072b8.jpeg",
    label: "Bauendreinigung",
    location: "Düsseldorf",
    desc: "Klinik – Bauend- & Detailreinigung",
    objectPos: "object-center",
  },
];

export default function ProofSection() {
  return (
    <section id="referenzen" className="py-24 md:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span className="text-xs font-bold tracking-widest uppercase text-gray-400 mb-4 block">Referenzen</span>
          <h2 className="text-4xl md:text-5xl font-bold text-black leading-tight mb-5" style={{ fontFamily: "'Inter', sans-serif" }}>
            Ergebnisse, auf die Sie sich verlassen können
          </h2>
          <p className="text-gray-500 text-base leading-relaxed">
            Bereits zahlreiche Objekte in Düsseldorf, Ratingen und Umgebung betreut – vom Mehrfamilienhaus bis zur Gewerbeimmobilie.
          </p>
        </div>

        {/* Uniform Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {projects.map((p, i) => (
            <div
              key={i}
              className="relative rounded-2xl overflow-hidden group cursor-pointer"
              style={{ height: "240px" }}
            >
              <img
                src={p.img}
                alt={p.label}
                className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/10 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-5">
                <div className="flex items-end justify-between">
                  <div>
                    <p className="text-white font-bold text-base">{p.desc}</p>
                    <p className="text-white/70 text-sm flex items-center gap-1 mt-1">
                      <i className="ri-map-pin-line text-xs"></i>
                      {p.location}
                    </p>
                  </div>
                  <span className="bg-white/20 backdrop-blur-sm border border-white/20 text-white text-xs font-semibold px-3 py-1.5 rounded-full whitespace-nowrap">
                    {p.label}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Stats */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mt-10 md:mt-16 bg-[#F9F7F4] rounded-2xl p-5 md:p-8">
          {[
            { value: "50+", label: "Mitarbeiter im Einsatz" },
            { value: "200+", label: "Betreute Objekte" },
            { value: "NRW-weit", label: "Einsatzgebiet" },
            { value: "24h", label: "Reaktionszeit" },
          ].map((s, i) => (
            <div key={i} className="text-center py-2">
              <p className="text-2xl md:text-4xl font-bold text-black mb-1">{s.value}</p>
              <p className="text-gray-500 text-xs md:text-sm">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
